module.exports = __webpack_public_path__ + "static/media/MA.4a27538f.png";